import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

interface AmazonRegistration {
  partnerId: string;
  tenantId: string;
  createdBy: string;
  createdAt: string;
  carrierAccountId: string;
  lastUpdatedAt: string;
  lastUpdatedBy: string;
  amazonSellingPartnerId?: string;
  refreshToken?: string;
  amazonRegistrationId: string;
  registeredAt?: string;
  lifecycleStage: string;
  amazonAuthCode?: string;
  registrationLink: string;
}

export const amazon = {
  search: {
    queryKey: 'ups-registration-service/amazon',
    fn: async (partnerId: string) => {
      const { data } = await GatewayAxiosClient.get<AmazonRegistration[]>(
        `/ups-registration-proxy/api/v1/carrier-connect/${partnerId}/amazon`,
      );

      return data;
    },
  },
  generateLink: async ({ partnerId, carrierAccountId }: { partnerId: string; carrierAccountId: string }) => {
    const { data } = await GatewayAxiosClient.get(
      `/ups-registration-proxy/api/v1/carrier-connect/${partnerId}/amazon/${carrierAccountId}`,
    );

    return { data, invalidateQueryKeys: [['ups-registration-service/amazon']] };
  },
  disconnect: async ({ partnerId, carrierAccountId }: { partnerId: string; carrierAccountId: string }) => {
    const { data } = await GatewayAxiosClient.put(
      `/ups-registration-proxy/api/v1/carrier-connect/${partnerId}/amazon/${carrierAccountId}/disconnect`,
    );

    return { data, invalidateQueryKeys: [['ups-registration-service/amazon']] };
  },
};
